import { gql, useLazyQuery } from '@apollo/client';

export enum ActivityType {
  CONVERSATIONS = 'CONVERSATIONS',
  COMMENTS = 'COMMENTS',
  CAMPAIGNS = 'CAMPAIGNS',
  FILE = 'FILE',
}

export const SEND_MESSAGE = gql`
  mutation send_message($data: SendMessageInputType) {
    send_message(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const GET_MESSAGES = gql`
  query get_messages($data: GetMessagesInputType) {
    response: get_messages(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const LIST_ACTIVITIES = gql`
  query list_activities($data: ListActivitesInputType) {
    response: list_activities(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const GET_USER_ACTIVITY = gql`
  query get_user_activity($data: UserActivityInputType) {
    response: get_user_activity(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const UPDATE_VIEW = gql`
  mutation update_view($data: UpdateViewInputType) {
    update_view(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const GET_QUICK_REPLIES = gql`
  query get_quick_replies($data: GetQuickRepliesInputType) {
    get_quick_replies(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const LIST_QUICK_REPLIES = gql`
  query list_quick_replies($data: ListQuickRepliesInputType) {
    response: list_quick_replies(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const SEND_QUICK_REPLY = gql`
  mutation send_quick_reply($data: SendQuickReplyInputType) {
    response: send_quick_reply(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const UPDATE_MANUAL_MODE = gql`
  mutation update_manual_mode($data: UpdateManualModeInputType) {
    update_manual_mode(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const CLOSE_CONVERSATION = gql`
  mutation close_conversation($data: CloseConversationInputType) {
    close_conversation(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const CREATE_QUICK_REPLY = gql`
  mutation CreateQuickReply($data: CreateQuickReplyInputType!) {
    create_quick_reply(data: $data) {
      hasError
      message
      data
    }
  }
`;

export const DELETE_QUICK_REPLY = gql`
  mutation DeleteQuickReply($data: DeleteQuickReplyInputType!) {
    delete_quick_reply(data: $data) {
      hasError
      message
      data
    }
  }
`;

export const CREATE_ACTIVITY = gql`
  mutation create_activity($data: CreateActivityInputType!) {
    create_activity(data: $data) {
      hasError
      message
      data
    }
  }
`;

export const LIST_CONVERSATIONS = gql`
  query list_conversations($data: ListConversationsInputType) {
    response: list_conversations(data: $data) {
      hasError
      data
      message
    }
  }
`;

export function useGetUserActivity() {
  return useLazyQuery(GET_USER_ACTIVITY);
}
